module.exports = __webpack_public_path__ + "static/img/lottery_preview.b40cba67.png";